module.exports = __webpack_public_path__ + "img/disableLeft.4c200858.svg";